import { object, number, union, z } from "zod";

export const FavouritesQueryParams = object({
  action: union([
    z.literal("LADY_ADD"),
    z.literal("LADY_REMOVE"),
    z.literal("PHOTO_ADD"),
    z.literal("PHOTO_REMOVE"),
    z.literal("VIDEO_ADD"),
    z.literal("VIDEO_REMOVE"),
  ]),
  favoriteObjectId: number(),
  userId: number(),
});

export type FavouritesQueryParams = z.infer<typeof FavouritesQueryParams>;
